import CircularProgress from "@mui/material/CircularProgress";
import Stack from "@mui/material/Stack";

export function LoadingScreen() {
  return (
    <Stack
      alignItems="center"
      width="100%"
      height="100%"
      justifyContent="center"
    >
      <CircularProgress />
    </Stack>
  );
}
